import VerticalNavigation from './VerticalNavigation';

class VerticalNavigationAPX extends VerticalNavigation {
  constructor(props) {
    super(props);  

    this.state = {
        redraw:false
    }
  }

  onClick(value, index){
    this.changeItem(value, index);

    this.props.data.APX.APXModuleCallback(value, index);
  }

 
}

export default VerticalNavigationAPX;